import DashboardHome from '@/components/Pages/Dashboard/DashboardHome.vue';
import GiftCards from '@/components/Pages/Home Page/GiftCards.vue';
import Packages from '@/components/Pages/Home Page/Packages.vue';
import TestPage from '@/components/Pages/TestPage.vue';
import Home from '@/components/Pages/Home Page/Home.vue';
import NewPassword from '@/components/Pages/User/NewPassword.vue';
import PrivacyPolicy from '@/components/Pages/Home Page/PrivacyPolicy.vue';
import Login from '@/components/Pages/Home Page/Login.vue';
import About from '@/components/Pages/Home Page/About.vue';
import BookingHome from '@/components/Pages/Booking Flow/BookingHome.vue';
import SubmitReview from '@/components/Pages/Customer/SubmitReview.vue';
import LocationsHome from '@/components/Pages/Home Page/Locations/LocationsHome.vue';
import ForwardToStripe from '@/components/Pages/Customer/ForwardToStripe.vue';
import PackageHome from '@/components/Pages/Package Flow/PackageHome.vue';
import TermsOfService from '@/components/Pages/Home Page/TermsOfService.vue';
import VendorSignUp from '@/components/Pages/Vendor/VendorSignUp.vue';
import OrderCancel from '@/components/Pages/Customer/OrderCancel.vue';
import FAQ from '@/components/Pages/Home Page/FAQ.vue';
import ServicesHome from '@/components/Pages/Home Page/Services/ServicesHome.vue';
import OrderConfirm from '@/components/Pages/Customer/OrderConfirm.vue';
import CustomerOrders from '@/components/Pages/Customer/CustomerOrders.vue';
import OrderAwaitingReview from '@/components/Pages/Customer/OrderAwaitingReview.vue';
import NotFound from '@/components/Views/UI/NotFound.vue';

import bookingSteps from './booking';
import packageSteps from './package';
import servicesPages from './services';
import locationsPages from './locations';
import dashboardPages from './dashboard';
import BlogHome from '@/components/Pages/Blog/BlogHome.vue';
import PublishHome from '@/components/Pages/Blog/PublishHome.vue';
import BlogPost from '@/components/Pages/Blog/BlogPost.vue';

// This is a function because if i simply import store and return an array SOMETHING breaks and it ends up being undefined.
// Just the existence of a store inside the beforeEnter routegaurd will cause this.
export default (store) => [
    {
        path: '',
        name: 'home',
        component: Home,
        meta: {
            preRender: true,
        },
    },
    {
        path: '/book',
        name: 'book',
        component: BookingHome,
        meta: {
            toolbarMode: 1,
            roles: ['admin', 'vendor'],
        },
        children: bookingSteps,
        beforeEnter(to, from, next) {
            const expectedIndex = store.state.booking.step - 1;
            const actualIndex = bookingSteps
                .map((x) => `/book/${x.path}`)
                .indexOf(to.path);
            if (
                (to.path === '/book' && expectedIndex === 0) ||
                actualIndex === expectedIndex
            ) {
                next();
            } else {
                next(`/book/${bookingSteps[expectedIndex].path}`);
            }
        },
    },
    {
        path: '/package',
        name: 'package',
        component: PackageHome,
        meta: {
            toolbarMode: 1,
        },
        children: packageSteps,
        beforeEnter(to, from, next) {
            const expectedIndex = store.state.packages.step - 1;
            console.log(store);
            // console.log({to, step:expectedIndex});
            const actualIndex = packageSteps
                .map((x) => `/package/${x.path}`)
                .indexOf(to.path);
            if (
                (to.path === '/package' && expectedIndex === 0) ||
                actualIndex === expectedIndex
            ) {
                next();
            } else {
                next(`/package/${packageSteps[expectedIndex].path}`);
            }
        },
    },
    {
        path: '/services',
        name: 'servicesRoot',
        component: ServicesHome,
        children: servicesPages,
        meta: {
            preRender: true,
        },
    },
    {
        path: '/locations',
        name: 'locationsRoot',
        component: LocationsHome,
        children: locationsPages,
    },
    {
        path: '/dashboard',
        name: 'dashboardRoot',
        component: DashboardHome,
        meta: {
            appbar: true,
            requiresAuth: true,
        },
        children: dashboardPages,
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            appbar: false,
            preRender: true,
        },
    },
    {
        path: '/blog',
        name: 'blog',
        component: BlogHome,
    },
    {
      path: '/blog/:permalink',
      name: 'post',
      component: BlogPost,
    },
    {
        path: '/publish',
        name: 'publish',
        component: PublishHome,
        meta: {
            roles: ['admin'],
        },
    },
    {
        path: '/publish/:id',
        name: 'publish',
        component: PublishHome,
        meta: {
            roles: ['admin'],
        },
    },
    {
        path: '/confirm/:order',
        name: 'bookConfirm',
        component: OrderConfirm,
    },
    {
        path: '/password/change/:token',
        name: 'changePassword',
        component: NewPassword,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/password/reset/:token',
        name: 'resetPassword',
        component: NewPassword,
    },
    {
        path: '/cancel/:order',
        name: 'bookCancel',
        component: OrderCancel,
    },
    {
        path: '/pending/:order',
        name: 'manualReview',
        component: OrderAwaitingReview,
    },
    {
        path: '/review/:booking',
        name: 'bookReview',
        component: SubmitReview,
    },
    {
        path: '/stripe/:order',
        name: 'forwardToStripeCheckout',
        component: ForwardToStripe,
    },
    {
        path: '/about',
        name: 'about',
        component: About,
        meta: {
            preRender: true,
        },
    },
    {
        path: '/gift-cards',
        name: 'gift cards',
        component: GiftCards,
        meta: {
            preRender: true,
        },
    },
    {
        path: '/packages',
        name: 'packages',
        component: Packages,
        meta: {
            preRender: true,
        },
    },
    {
        path: '/faqs',
        name: 'faqs',
        component: FAQ,
        meta: {
            preRender: true,
        },
    },
    {
        path: '/orders',
        name: 'customer orders',
        component: CustomerOrders,
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/terms-of-service',
        name: 'Terms Of Service',
        component: TermsOfService,
        meta: {
            preRender: true,
        },
    },
    {
        path: '/privacy-policy',
        name: 'Privacy Policy',
        component: PrivacyPolicy,
        meta: {
            preRender: true,
        },
    },
    {
        path: '/become-a-pro',
        name: 'Become a Pro',
        component: VendorSignUp,
        meta: {
            preRender: true,
        },
    },

    {
        path: '*',
        name: '404',
        component: NotFound,
    },
];
